export const decideDesignType = (designType) => {
    if (designType === 'Immersive')
        return 'Article';
    if (designType === 'SpecialReport')
        return 'Article';
    if (designType === 'GuardianLabs')
        return 'AdvertisementFeature';
    return designType;
};
